import React from "react";
import CompanyEnvironmentalPolicyPage from "@components/Pages/CompanyEnvironmentalPolicyPage/CompanyEnvironmentalPolicyPage";

export default function Software() {
    return <CompanyEnvironmentalPolicyPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../../locales/${locale}.json`)).default,
        },
    };
}
